import { baseApi } from '@/features/api/baseApi';
import directus, { type DirectusErrorType } from '@/features/api/directus';
import type { FluxPage, FluxQueryArg, FluxRow, FluxScellementArg } from '@/models/flux.type';
import { triggerFlow } from '@directus/sdk';

const FLUX_FLOW_ID = '72969041-a369-488d-ae2d-7f2483465ba7';
// TODO : renseigner l'id du flow de modification de la date de scellement.
const FLUX_FLOW_SCELLEMENT_ID = '00000000-0000-0000-0000-000000000000';

const fluxApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ['flux'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getFlux: builder.query<FluxPage, FluxQueryArg>({
        keepUnusedDataFor: 3600, // 1 hour
        queryFn: async ({ page, pageSize, fields, orderBy, filter }) => {
          try {
            const data = await directus.request<FluxPage>(
              triggerFlow('GET', FLUX_FLOW_ID, {
                page: String(page),
                pageSize: String(pageSize),
                ...(fields?.length ? { fields: fields.join(',') } : {}),
                ...(orderBy ? { orderBy } : {}),
                ...(filter ? { filter: filter as unknown as string } : {}),
              }),
            );
            return { data };
          } catch (error: unknown) {
            return { error: error as DirectusErrorType };
          }
        },
        providesTags: ['flux'],
      }),
      updateFluxScellement: builder.mutation<FluxRow, FluxScellementArg>({
        queryFn: async body => {
          try {
            const data = await directus.request<FluxRow>(
              triggerFlow(
                'POST',
                FLUX_FLOW_SCELLEMENT_ID,
                body as unknown as Record<string, string>,
              ),
            );
            return { data };
          } catch (error: unknown) {
            return { error: error as DirectusErrorType };
          }
        },
        invalidatesTags: ['flux'],
      }),
    }),
  });

export const { useGetFluxQuery, useUpdateFluxScellementMutation } = fluxApi;
